import { UploadableModality } from "@/constants/dropzone";

export const getDisplayLabelForModality = (modality: UploadableModality) => {
  switch (modality) {
    case "IMAGE":
      return "Image";
    case "VIDEO":
      return "Video";
    case "AUDIO":
      return "Audio";
    case "THREE_D":
      return "Mesh";
  }
};
